import { IoSearch, IoShieldCheckmarkSharp } from "react-icons/io5";
import { FaGlobe } from "react-icons/fa6";

function WhyChoose() {

    const cardsInfo = [
        {
            icon: IoSearch,
            title: 'Streamlined Recruitment',
            desc: 'Manage the entire hiring process from job posting to onboarding in one unified dashboard.Track applications, schedule interviews, and make faster decisions.'
        },
        {
            icon: IoShieldCheckmarkSharp,
            title: 'Verified Candidate & Auto tracking',
            desc: 'All candidate profiles and track progress to ensure credibility and reduce risks and data loss.'
        },
        {
            icon: FaGlobe,
            title: 'Pan-India Talent Network',
            desc: 'Access a diverse talent pool across all major cities and industries, helping you hire the right candidate wherever they are.'
        }
    ]

    return (
        <div className='p-4 py-14 sm:p-8 md:p-12 2xl:px-[10%] text-center bg-slate-50 rounded-xl'>

            <h3 className="text-4xl font-semibold text-secondary-600">Why Choose Our ATS Platform?</h3>
            <p className="my-5 text-lg text-slate-800">The most reliable system for recruiters and hiring teams to manage talent efficiently.</p>
            <div className="my-5 flex flex-wrap md:flex-nowrap gap-5 justify-center items-stretch">
                {
                    cardsInfo?.map((card, i) => (
                        <div className="text-left bg-white shadow-lg p-5 rounded-2xl w-full sm:w-5/6 md:w-ful" key={i}>
                            <card.icon className="text-slate-700 bg-blue-50 text-5xl rounded-full p-2" />
                            <h4 className="my-2 text-xl font-semibold text-primary-400">{card.title}</h4>
                            <p className="text-sm text-slate-700">{card.desc}</p>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default WhyChoose